// socket.js
import { io } from "socket.io-client";
import { socketIoInterval } from '@/constants/systemInterval';

const socket = io(`http://${window.location.hostname}:5625/`);

export default {
    install: (app) => {
        app.config.globalProperties.$socket = socket;

        // 用于存储事件监听器和定时器的引用，按照 eventName 进行管理
        const socketEvents = {};

        app.config.globalProperties.$createSocketIO = function (params) {
            let eventName = params.eventName,
                eventAction = params.eventAction,
                reqParams = params.reqParams,
                intervalTime = params.intervalTime || socketIoInterval;

            // 如果已经有该事件的监听器和定时器，先移除
            if (socketEvents[eventName]) {
                socket.off(eventName, socketEvents[eventName].listener);
                clearInterval(socketEvents[eventName].interval);
            }

            // 创建新的监听器函数
            const listener = (...args) => eventAction(...args);
            socket.on(eventName, listener);

            // 定义发送请求的函数
            const emitRequest = () => {
                socket.emit(eventName, reqParams);
            };

            // 立即发送一次请求
            emitRequest();

            // 设置定时器，定期发送请求
            let interval = setInterval(() => {
                emitRequest();
            }, intervalTime);

            // 保存监听器和定时器的引用
            socketEvents[eventName] = {
                listener,
                interval
            };

            return {
                eventName
            };
        };

        /**
         * 单次请求的 SocketIO：只发送一次请求，后台逐条推送结果
         */
        app.config.globalProperties.$createSocketIOOnce = function (params) {
            let eventName = params.eventName,
                eventAction = params.eventAction,
                reqParams = params.reqParams;

            // 如果已经有该事件的监听器，先移除
            if (socketEvents[eventName]) {
                socket.off(eventName, socketEvents[eventName].listener);
                if (socketEvents[eventName].interval) {
                    clearInterval(socketEvents[eventName].interval);
                }
            }

            // 创建新的监听器函数
            const listener = (...args) => eventAction(...args);
            socket.on(eventName, listener);

            // 只发送一次请求
            socket.emit(eventName, reqParams);

            // 保存监听器引用，方便后续关闭
            socketEvents[eventName] = {
                listener,
                interval: null
            };

            return {
                eventName
            };
        };

        app.config.globalProperties.$offSocket = function (params) {
            if (params) {
                let eventName = params.eventName;
                if (socketEvents[eventName]) {
                    // 移除事件监听器和定时器
                    socket.off(eventName, socketEvents[eventName].listener);
                    if (socketEvents[eventName].interval) {
                        clearInterval(socketEvents[eventName].interval);
                    }
                    delete socketEvents[eventName];
                    console.log(`已移除事件 ${eventName} 的监听器和定时器`);
                }
            }
        };
    }
};
